import { isFlagEnabled } from "@/utils/featureFlags";

// Раздел «Карта» в TMA: выключен — вместо заказа и экранов карт шторка «Недоступно в Telegram»
export const isCardsEnabled = () => isFlagEnabled("tmaCards");

export const isCardsV3Enabled = () => isFlagEnabled("tmaCardsV3Enabled");
